import React from 'react';
import { toDecimalPoint } from '../../../utils/decimalUtils';
import DecimalInput from '../../fields/DecimalInput';

const CauseSignModal = ({
  isModalOpen,
  selectedRowId,
  modalData,
  handbooks,
  loadedSigns,
  isLoadingSigns,
  openPicker,
  openYearPicker,
  openSignsPicker,
  addModalRow,
  removeModalRow,
  closeModal,
  saveModalData,
  updateModalData
}) => {
  if (!isModalOpen) return null;
  const formatCauseLabel = (cause) => {
    if (!cause) return '';
    const code = String(cause.code ?? '').trim();
    return code ? `${cause.name} (${code})` : cause.name;
  };

  return (
    <div className="modal-overlay" style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000
    }}>
      <div className="modal-content" style={{
        backgroundColor: 'white',
        borderRadius: '8px',
        padding: '20px',
        maxWidth: '800px',
        width: '90%',
        maxHeight: '80vh',
        overflow: 'auto',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)'
      }}>
        <div style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center', 
          marginBottom: '20px',
          borderBottom: '1px solid #eee',
          paddingBottom: '10px'
        }}>
          <h3 style={{ margin: 0, fontSize: '18px', fontWeight: '600' }}>
            Причина/признак ослабления, повреждения насаждения (Строка {selectedRowId})
          </h3>
          <button
            onClick={closeModal}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '20px',
              cursor: 'pointer',
              color: '#666'
            }}
          >
            ×
          </button>
        </div>

        <div style={{ marginBottom: '20px' }}>
          <table className="table" style={{ marginBottom: 0 }}>
            <thead>
              <tr>
                <th style={{ minWidth: '200px' }}>Причина</th>
                <th style={{ minWidth: '100px' }}>Год</th>
                <th style={{ minWidth: '200px' }}>Признак</th>
                <th style={{ minWidth: '120px' }}>% деревьев</th>
                <th style={{ minWidth: '80px' }}>Действия</th>
              </tr>
            </thead>
            <tbody>
              {modalData.map((item, index) => (
                <tr key={item.id}>
                  <td>
                    <div 
                      className="reference-cell"
                      onClick={() => openPicker('prichina', 10, item.id)}
                      style={{ 
                        width: '100%',
                        height: '100%',
                        minHeight: '40px',
                        cursor: 'pointer',
                        background: 'transparent',
                        border: 'none',
                        padding: '0',
                        margin: '0',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between'
                      }}
                    >
                      <span style={{ 
                        color: item.prichina ? '#000' : '#6c757d',
                        fontSize: '14px',
                        flex: 1,
                        padding: '8px'
                      }}>
                        {(() => {
                          const handbook = handbooks.find(h => h.id === 10);
                          if (handbook && handbook.references && item.prichina) {
                            const selectedOption = handbook.references.find(r => r.id.toString() === item.prichina);
                            return selectedOption ? formatCauseLabel(selectedOption) : 'Выберите причину';
                          }
                          return 'Выберите причину';
                        })()}
                      </span>
                      <span style={{ color: '#6c757d', fontSize: '12px', paddingRight: '8px' }}>☰</span>
                    </div>
                  </td>
                  <td>
                    <div 
                      className="reference-cell"
                      onClick={() => openYearPicker(item.id)}
                      style={{ 
                        width: '100%',
                        height: '100%',
                        minHeight: '40px',
                        cursor: 'pointer',
                        background: 'transparent',
                        border: 'none',
                        padding: '0',
                        margin: '0',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between'
                      }}
                    >
                      <span style={{ 
                        color: item.godpovr ? '#000' : '#6c757d',
                        fontSize: '14px',
                        flex: 1,
                        padding: '8px'
                      }}>
                        {item.godpovr || 'Выберите год'}
                      </span>
                      <span style={{ color: '#6c757d', fontSize: '12px', paddingRight: '8px' }}>☰</span>
                    </div>
                  </td>
                  <td>
                    <div 
                      className="reference-cell"
                      onClick={() => openSignsPicker(item.id)}
                      style={{ 
                        width: '100%',
                        height: '100%',
                        minHeight: '40px',
                        cursor: item.prichina ? 'pointer' : 'not-allowed',
                        background: item.prichina ? 'transparent' : '#f8f9fa',
                        border: 'none',
                        padding: '0',
                        margin: '0',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        opacity: item.prichina ? 1 : 0.6
                      }}
                    >
                      <span style={{ 
                        color: item.prizn ? '#000' : '#6c757d',
                        fontSize: '14px',
                        flex: 1,
                        padding: '8px'
                      }}>
                        {(() => {
                          if (isLoadingSigns && item.prichina && !item.prizn) {
                            return 'Загрузка признаков...';
                          }
                          
                          if (item.prizn) {
                            // Находим название признака по ID
                            const handbook = handbooks.find(h => h.id === 10);
                            if (handbook && handbook.references && item.prichina) {
                              const selectedCause = handbook.references.find(r => r.id.toString() === item.prichina);
                              if (selectedCause && loadedSigns[selectedCause.name]) {
                                const selectedSign = loadedSigns[selectedCause.name].find(s => s.value === item.prizn);
                                return selectedSign ? selectedSign.label : item.prizn;
                              }
                            }
                            return item.prizn;
                          }
                          
                          return 'Выберите признак';
                        })()}
                      </span>
                      <span style={{ color: '#6c757d', fontSize: '12px', paddingRight: '8px' }}>☰</span>
                    </div>
                  </td>
                  <td>
                    <DecimalInput
                      value={item.dolaprizn || ''}
                      onChange={(e) => {
                        const value = toDecimalPoint(e.target.value);
                        if (value === '' || (Number(value) >= 0 && Number(value) <= 100)) {
                          if (updateModalData) {
                            updateModalData(item.id, 'dolaprizn', value);
                          }
                        }
                      }}
                      onBlur={(e) => {
                        const value = toDecimalPoint(e.target.value);
                        if (value !== '' && (Number(value) < 0 || Number(value) > 100)) {
                          e.target.value = '';
                          if (updateModalData) {
                            updateModalData(item.id, 'dolaprizn', '');
                          }
                        }
                      }}
                      style={{ 
                        width: '100%',
                        height: '100%',
                        minHeight: '40px',
                        textAlign: 'center',
                        background: 'transparent',
                        border: 'none',
                        padding: '8px',
                        margin: '0',
                        color: item.dolaprizn ? '#000' : '#6c757d',
                        fontSize: '14px',
                        outline: 'none'
                      }}
                      placeholder="0-100"
                    />
                  </td>
                  <td>
                    <div style={{ display: 'flex', gap: '5px', justifyContent: 'center' }}>
                      <button
                        type="button"
                        onClick={addModalRow}
                        style={{
                          padding: '4px 8px',
                          fontSize: '12px',
                          backgroundColor: '#6c757d',
                          color: 'white',
                          border: '1px solid #6c757d',
                          borderRadius: '4px',
                          cursor: 'pointer'
                        }}
                        title="Добавить строку"
                      >
                        +
                      </button>
                      <button
                        type="button"
                        onClick={() => removeModalRow(item.id)}
                        disabled={modalData.length === 1}
                        style={{
                          padding: '4px 8px',
                          fontSize: '12px',
                          backgroundColor: '#6c757d',
                          color: 'white',
                          border: '1px solid #6c757d',
                          borderRadius: '4px',
                          cursor: modalData.length === 1 ? 'not-allowed' : 'pointer',
                          opacity: modalData.length === 1 ? 0.5 : 1
                        }}
                        title="Удалить строку"
                      >
                        -
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          borderTop: '1px solid #eee',
          paddingTop: '15px'
        }}>
          <button
            onClick={addModalRow}
            className="btn btn-outline-primary"
            style={{ height: '40px' }}
          >
            Добавить строку
          </button>
          <div>
            <button
              onClick={closeModal}
              className="btn btn-outline-secondary"
              style={{ height: '40px', marginRight: '10px' }}
            >
              Отмена
            </button>
            <button
              onClick={saveModalData}
              className="btn btn-primary"
              style={{ height: '40px' }}
            >
              Сохранить
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CauseSignModal;

